var render = function () {
  var _vm$currentRound, _vm$currentRound2, _vm$currentRound3, _vm$currentRound4, _vm$currentRound5, _vm$currentRound6;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('section', {
    ref: "truckStage",
    class: {
      'truck-stage': true,
      isMobile: _vm.isMobile
    }
  }, [_c('div', {
    ref: "truckContainer",
    staticClass: "truck-container"
  }, [_c('p', {
    ref: "provisionalLettersContainer",
    staticClass: "provisional-letters-container"
  }, _vm._l((_vm$currentRound = _vm.currentRound) === null || _vm$currentRound === void 0 ? void 0 : _vm$currentRound.letterCombo, function (char, index) {
    return _c('span', {
      key: char + index,
      staticClass: "letter-to-drop",
      attrs: {
        "track-by": "$index"
      }
    }, [_vm._v("\n              " + _vm._s(char) + "\n            ")]);
  }), 0), (_vm$currentRound2 = _vm.currentRound) !== null && _vm$currentRound2 !== void 0 && _vm$currentRound2.letterCombo ? _c('div', {
    ref: "truckLoad",
    staticClass: "truck-load"
  }, [_c('blinking-cursor-text', {
    staticClass: "type-line",
    attrs: {
      "text": (_vm$currentRound3 = _vm.currentRound) === null || _vm$currentRound3 === void 0 ? void 0 : _vm$currentRound3.letterCombo,
      "textStep": this.progress.stepIndex
    }
  }), _c('img', {
    attrs: {
      "alt": "Dump truck load",
      "src": _vm.truckLoadPath
    }
  })], 1) : _vm._e(), _c('img', {
    staticClass: "truck-body",
    attrs: {
      "alt": "Dump truck",
      "src": _vm.truckBodyPath
    }
  })])]), (_vm$currentRound4 = _vm.currentRound) !== null && _vm$currentRound4 !== void 0 && _vm$currentRound4.steps && (_vm$currentRound5 = _vm.currentRound) !== null && _vm$currentRound5 !== void 0 && _vm$currentRound5.wordPart ? _c('section', {
    ref: "wordToCompleteStage",
    class: {
      'word-to-complete-stage': true,
      isMobile: _vm.isMobile
    }
  }, _vm._l((_vm$currentRound6 = _vm.currentRound) === null || _vm$currentRound6 === void 0 ? void 0 : _vm$currentRound6.steps, function (step, index) {
    return _c('div', {
      key: index,
      class: 'word-container-' + index
    }, _vm._l(step.answer, function (letter, charIndex) {
      return _c('span', {
        key: charIndex + letter,
        class: _vm.getCharacterClass(charIndex, step.answer)
      }, [_vm._v("\n            " + _vm._s(letter) + "\n          ")]);
    }), 0);
  }), 0) : _vm._e()])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }